import useMenu, { BRANCH_MENUS } from '@hooks/useMenu'
import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import { getBranch } from '@reducers/branch/branch.reducer'

import BranchAccessLogPage from '@pages/Branch/AccessLogPage'
import BranchCashPage from '@pages/Branch/CashPage'
import BranchConfigPage from '@pages/Branch/ConfigPage'
import BranchDashboardPage from '@pages/Branch/DashboardPage'
import BranchEventPage from '@pages/Branch/EventPage'
import BranchExpenditurePage from '@pages/Branch/ExpenditurePage'
import BranchNoticePage from '@pages/Branch/NoticePage'
import BranchRolePage from '@pages/Branch/RolePage'
import BranchTenantPage from '@pages/Branch/TenantPage'
import NotFoundPage from '@pages/Error/NotFoundPage'

import BranchBillRouter from './BillRouter'
import BranchContractRouter from './ContractRouter'
import BranchProductRouter from './ProductRouter'
import BranchRentalRouter from './RentalRouter'
import BranchServiceRouter from './ServiceRouter'

const routePages = BRANCH_MENUS.map((m) => {
  let component: JSX.Element = <div />

  if (m.key === 'dashboard') component = <BranchDashboardPage />
  else if (m.key === 'contract') component = <BranchContractRouter />
  else if (m.key === 'bill') component = <BranchBillRouter />
  else if (m.key === 'rental') component = <BranchRentalRouter />
  else if (m.key === 'event') component = <BranchEventPage />
  else if (m.key === 'tenant') component = <BranchTenantPage />
  else if (m.key === 'notice') component = <BranchNoticePage />
  else if (m.key === 'expenditure') component = <BranchExpenditurePage />
  else if (m.key === 'product') component = <BranchProductRouter />
  else if (m.key === 'service') component = <BranchServiceRouter />
  else if (m.key === 'cash') component = <BranchCashPage />
  else if (m.key === 'accessLog') component = <BranchAccessLogPage />
  else if (m.key === 'role') component = <BranchRolePage />
  else if (m.key === 'config') component = <BranchConfigPage />

  return { ...m, component }
})

export default function BranchRouter(): JSX.Element {
  const dispatch = useDispatch()
  const { hqId, branchId, branchMenus } = useMenu()
  useEffect(() => {
    dispatch(getBranch(hqId, branchId))
  }, [branchId])

  const { path } = useRouteMatch()

  const routes = useMemo(
    () => routePages.filter((rp) => branchMenus.some((bm) => bm.key === rp.key)),
    [routePages, branchMenus]
  )

  return (
    <Switch key={branchId}>
      {routes.map((ar) => (
        <Route path={`${path}/${ar.path}`} key={ar.key}>
          {ar.component}
        </Route>
      ))}
      <Route>
        <NotFoundPage />
      </Route>
    </Switch>
  )
}
